// Portal.js
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const Portal = ({ children }) => {
  const [portalNode, setPortalNode] = useState(null);

  useEffect(() => {
    const portalRoot = document.getElementById("portal-root");
    if (portalRoot) {
      const node = document.createElement("div");
      portalRoot.appendChild(node);
      setPortalNode(node);

      return () => {
        portalRoot.removeChild(node);
      };
    }
  }, []);

  if (!portalNode) return null;

  return createPortal(children, portalNode);
};

export default Portal;
